<div id="dialog-confirmacion-registro" class="d-flex flex-column justify-content-between h-100">
    <div class="p-3">
        <div class="text-end">
            <span class="material-symbols-outlined" [mat-dialog-close]="true" role="button" title="Cerrar">close</span>
        </div>
        <h2 class="primary-900">Regístrate o inicia sesión</h2>
        <div class="linea-separadora-2 border-primary-100 mt-3 mb-5"></div>
        <div class="text-md-center mt-4">
            <span class="material-symbols-outlined mat-icon-size-50 filled primary-800 mb-3">account_circle</span>
            <p class="p2-regular mb-3">
                Para ver <span class="p2-bold">más detalles de las operaciones y poder invertir</span> debes de estar
                registrado
                o inicia sesión con tu usuario.
            </p>
        </div>
    </div>

    <div class="bg-primary-100 text-md-end">
        <div class="px-3 py-4">
            @if (data.isPlatformFactoring) {
            <app-btn-link [linkUrl]="'/login'" [linkTitle]="'Iniciar sesión'" [linkStyle]="'secondary'"
                [linkClass]="'me-3'" (click)="closeDialog()"
                [linkReturnUrl]="'/panel-inversor/' + data.returnUrl"></app-btn-link>
            <app-btn-link [linkUrl]="'/registro'" [linkClass]="'hover-primary-300'" [linkTitle]="'Regístrate'"
                (click)="closeDialog()" [linkReturnUrl]="'/panel-inversor/' + data.returnUrl"></app-btn-link>
            }@else {
            <app-btn-link [linkUrl]="'/login'" [linkTitle]="'Iniciar sesión'" [linkStyle]="'secondary'"
                [linkClass]="'me-3'" (click)="closeDialog()" 
                [linkReturnUrl]="(data.domainUrl ? data.domainUrl : '') + '/panel-inversor/' + data.returnUrl"></app-btn-link>
            <app-btn-link [linkUrl]="'/registro'" [linkClass]="'hover-primary-300'" [linkTitle]="'Regístrate'"
                (click)="closeDialog()" [linkReturnUrl]="(data.domainUrl ? data.domainUrl : '') + '/panel-inversor/' + data.returnUrl"></app-btn-link>
            }

        </div>
    </div>
</div>